import Aos from "aos";
import { useEffect } from "react";


const SolarFinancingContactUs = () => {
    useEffect(() => {
        Aos.init({
            duration: 1000,
        });
    }, []);

    return (
        <section className="cta-upgrade-section">
            <div className="cta-content-wrapper">
                <div className="cta-left-panel" data-aos="fade-right">
                    <h2>Ready to upgrade to solar?</h2>
                    <p className="cta-sub-instructions">Simply call or chat on WhatsApp with us:</p>

                    <div className="phone-line-card">
                        <span className="line-label">Lagos Phone Line</span>
                        <a href="tel:+2349166416423" className="line-number">0916 641 6423</a>
                    </div>

                    <div className="phone-line-card">
                        <span className="line-label">Abuja Phone Line</span>
                        <a href="tel:+2349125501463" className="line-number">0912 550 1463</a>
                    </div>

                    <a href="mailto:partnership@checkoff.finance" className="email-link">
                        <button className="btn-email-action" >
                            Send Us An Email
                        </button>
                    </a>
                </div>

                <div className="cta-right-panel" data-aos="fade-up">
                    <img
                        src={`${process.env.PUBLIC_URL}/assets/img/contact-us-solar.png`}
                        alt="Excited customer upgrade presentation"
                        className="cta-character-image"
                    />
                </div>
            </div>
        </section>
    );
};

export default SolarFinancingContactUs;